

    function load() {
        $('.preloader1').delay(900).fadeOut(500);
    }
    $(window).on('load', load());

$(document).ready(function(){

$(".shopify-buy__product__compare-price").css("color", "red");

 $(document).on('click',".add_to_cart",function(){
   var v_id = $(this).parents('.form').find('.hidden-var').val();

console.log(v_id);
var id= v_id ;
$.ajax({
type: 'POST', 
url: '/cart/add',
dataType: 'json', 
data: {id:id,quantity:1}, 
success: function(){
location.href="/cart";
}
});
}) 
  
 $('.one-half-column-right ul').slick({
    slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
   dots:true,
   infinite: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        autoplay: true,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        autoplay: true,
        slidesToScroll: 1
      }
    }

  ]
  });
  
  
  $('#featured-prod-slider').slick({
    slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 1500,
   dots:false,
   infinite: false,
  arrows: true,
    
  responsive: [
    {
      breakpoint: 1215,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false
      }
    },
        {
      breakpoint: 788,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false
      }
    }

  ]
  });
  
  
  $('.home_main_banner').slick({
    slideToShow:1,
    slidesToScroll: 1,
    arrows:false,
    dots:true,
    infinite:true,
    mobileFirst:true
 
    
  });
  
  $('.product_slider .slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable:true,
  arrows:false,
  asNavFor: '.product_slider .slider-nav',  
  infinite: false,
  responsive: [     
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      }
    }
  ]
});

$('.product_slider .slider-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.product_slider .slider-for',
  arrows: false,
  infinite:false,
    focusOnSelect: true,
  
  prevArrow:"<img class='prev slick-prev' src='https://cdn.shopify.com/s/files/1/0268/1893/7011/files/Up-arrow.png?v=1635826326'>",
  nextArrow:"<img class='next slick-next' src='https://cdn.shopify.com/s/files/1/0268/1893/7011/files/Down-arrow.png?v=1635826326'>",
  responsive: [     
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1 ,

      }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
        
        mobileFirst:true,
        draggable:true,
        slidesToShow: 4

      }
    },
    {
      breakpoint: 576,
      settings: {
        vertical: false,
        
        mobileFirst:true,
        draggable:true,
        slidesToShow: 3

      }
    },
    {

    },
    {
      breakpoint: 376,
      settings: {
        vertical: false,
        
        mobileFirst:true,
        draggable:true,
        slidesToShow: 2

      }
    }
  ]
}); 
  
// /* komal 23/11 product tab js */

 $('ul.tabs').each(function(){ 

 var active, content, links = $(this).find('a');

 active = links.first().addClass('active');

 content = $(active.attr('href'));

 links.not(':first').each(function () {

 $($(this).attr('href')).hide();

 });

 $(this).find('a').click(function(e){

 active.removeClass('active');

 content.hide();

 active = $(this);

 content = $($(this).attr('href'));

 active.addClass('active');

 content.show();

 return false;

 });

 });
// /* komal 23/11 product tab js */
  
// /* komal 24/11 quickview pop image slider */
$(document).on('click','a.product_cart_icon',function(){

    $(this).parents('.card-wrapper').next().css('display','block');
    $('body').toggleClass('model_open');

    $('.product_slider_popup .slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: false,
      dots:false,

      asNavFor: '.product_slider_popup .slider-nav',
      responsive: [     
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
          }
        }
      ]

    });
    $('.product_slider_popup .slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product_slider_popup .slider-for',
      dots: false,
      focusOnSelect: true,
      // vertical: true,
      arrows:false,
      infinite: false,
      responsive: [     
        {
          breakpoint: 1200,
          settings: {
            vertical:false,
            slidesToShow: 3,
            slidesToScroll: 1 ,
            arrows: false,
          }
        },
        {
          breakpoint: 769,
          settings: {
            vertical:false,
            slidesToShow: 4,
            arror:false,
            infinite: true

          }
        },
        {
          breakpoint: 577,
          settings: {
            vertical:false,
            slidesToShow: 3,
            arror:false,
            infinite: true

          }
        },
           {
          breakpoint: 361,
          settings: {
            vertical:false,
            slidesToShow: 2,
            arror:false,
            infinite: true

          }
        }
      ]
    });


  }); 
// /* komal 24/11 quickview pop image slider */
  
// /* komal variant wise add to cart from quickview popup 25/11 */   
  $(document).on('click','.model_box .product-form__buttons .product-form__submit',function(evt){
    debugger;
    evt.preventDefault();

    //alert($('.model_box .quantity__input').val());

    var qty = $('.model_box .quantity__input').val();
    var data = {
      "id": $(this).parents('form').find('[name="id"]').val(),
      "quantity": qty
    }

    debugger;
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        //alert('added');
        $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");

        $('.model_box').css('display','none');   

        $('.cart-notification-wrapper').css('display','flex'); 
      }
    })
  }); 

  $('.close_popup').click(function () {
    $('.model_box').css('display','none');  
    $('.product_slider_popup .slider-for').slick('unslick');
    $('.product_slider_popup .slider-nav').slick('unslick');

  });
  
  

    $(document).on('click','.quickview_box #color-variant li a',function(){
       
       
       //var color = $(this).val();
       if ($(this).parent('li').hasClass("active")) {
        $(this).parent('li').removeClass("active");
         }
       else{
        
         $('.quickview_box #color-variant li').removeClass("active");
          $(this).parent('li').addClass("active");
       }
       
      var hd_id = $(this).attr('data-id');
       var color = $(this).attr("data-value");
     
		var size = $(this).closest('.no-js-hidden').find('#size-variant .active a').attr("data-value");
      
       var variant = color +" / " + size;
       //alert(variant);
       if($(".main_select option[value='"+variant+"']").length > 0){
         $(".main_select option:selected").removeAttr("selected");
         $(".main_select option[value='"+variant+"']").attr("selected","selected").trigger('change');
         
        var id = $(".main_select option[value='"+variant+"']:selected").attr('data-id');
         
        $('.product-form #hidden-var').attr("value",id);
         
       }
         
 });
  
  $(document).on('click','.quickview_box #size-variant li a',function(){
       
         debugger;
       //var color = $(this).val();
       if ($(this).parent('li').hasClass("active")) {
        $(this).parent('li').removeClass("active");
         }
       else{
        
         $('.quickview_box #size-variant li').removeClass("active");
          $(this).parent('li').addClass("active");
       }
       
      var hd_id = $(this).attr('data-id');
       var size = $(this).attr("data-value");
     
		var color = $(this).closest('.no-js-hidden').find('#color-variant .active a').attr("data-value");
      
       var variant = color +" / " + size;
       //alert(variant);
       if($(".main_select option[value='"+variant+"']").length > 0){
         $(".main_select option:selected").removeAttr("selected");
         $(".main_select option[value='"+variant+"']").attr("selected","selected").trigger('change');
         
        var id = $(".main_select option[value='"+variant+"']:selected").attr('data-id');
         
        $('.product-form #hidden-var').attr("value",id);
         
       }

});

  
//   header js start
   $( "details .header__menu-item.main-shop-link" ).hover(function() {
      $(".level_two:first-of-type").find(".header__menu-item").addClass("active");
       $(".level_two:first-of-type").find(".header__submenu").addClass("show_me");
  });
 
   $(".header__inline-menu details-disclosure > details").hover(function(){
    $(this).attr("open","open");
    $(this).find('details').attr("open","open");
     $('.level_two detail').parents(".level_two:first-of-type").find(".header__submenu").addClass("show_me");
      $('.level_two detail').parents(".level_two:first-of-type").find(".header__menu-item").addClass("active");
  }, function(){
    $(this).removeAttr("open");
    $(this).find('details').attr("open","open");
  });
 $('.level_two detail').hover(function(){
//     debugger;
    $(this).parents(".level_two:first-of-type").find(".header__menu-item").removeClass("active");
    $(this).parents(".level_two:first-of-type").find(".header__submenu").removeClass("show_me");
    $(this).parents(".level_two").find(".header__submenu").addClass("show_me");
    $(this).parents(".level_two").find(".header__menu-item").addClass("active");
  },function(){
    $(this).parents(".level_two").find(".header__submenu").removeClass("show_me");
    $(this).parents(".level_two").find(".header__menu-item").removeClass("active");
  });
   $( ".level_two:last-child detail").click(function() {
   $('.level_two detail').parents(".level_two:first-of-type").find(".header__submenu").removeClass("show_me");
      $('.level_two detail').parents(".level_two:first-of-type").find(".header__menu-item").removeClass("active");
     
  });
  $( ".level_two:last-child detail").hover(function() {
   $('.level_two detail').parents(".level_two:first-of-type").find(".header__submenu").removeClass("show_me");
      $('.level_two detail').parents(".level_two:first-of-type").find(".header__menu-item").removeClass("active");
     
  });
  
});  


$(window).scroll(function(){
    if ($(window).scrollTop() >= 90) {
        $('.header').addClass('fixed-header');
    }
    else {
        $('.header').removeClass('fixed-header');
    }
});


